import styled from 'styled-components';

const DeleteForm = ({
  password,
  setPassword,
  onSubmit,
  onCancel,
  checkMessage,
}) => {
  return (
    <StyledForm onSubmit={(e) => onSubmit(e)}>
      <h4>메시지 삭제</h4>
      <label htmlFor="password">작성 시 입력한 비밀번호를 입력해 주세요.</label>
      <input
        type="password"
        name="password"
        id="password"
        placeholder="비밀번호"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      {checkMessage && <p>{checkMessage}</p>}
      <StyledUl>
        <li>
          <StyledButton type="button" onClick={onCancel}>
            취소
          </StyledButton>
        </li>
        <li>
          <StyledButton disabled={password.length == 0}>삭제</StyledButton>
        </li>
      </StyledUl>
    </StyledForm>
  );
};

const StyledForm = styled.form`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 70%;
  max-width: 30rem;
  padding: 2rem;
  background: var(--background);
  border: 1px solid var(--grayLv1);
  border-radius: 2rem;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.04);
  box-sizing: border-box;
  text-align: center;
  font-family: var(--pretendard);
  font-size: 1.4rem;
  line-height: 1.6rem;
  font-weight: 400;

  input {
    padding: 1rem;
    border: 1px solid var(--grayLv2);
    border-radius: 0.8rem;
    box-sizing: border-box;
  }

  p {
    font-size: 1.2rem;
    color: var(--error);
    margin-top: -1rem;
  }
`;

const StyledUl = styled.ul`
  display: flex;
  gap: 1rem;

  li {
    flex-grow: 1;
  }
`;

const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 3rem;
  box-sizing: border-box;
  padding: 0.5rem 1rem;
  background: var(--background);
  border: 1px solid var(--grayLv2);
  border-radius: 1rem;
  color: var(--surface);

  &:disabled {
    background-color: var(--grayLv2);
    color: var(--grayLv3);
  }
`;

export default DeleteForm;
